module.exports = __webpack_public_path__ + "img/corrugatedBox6.67b96517.jpg";